import React from 'react';
import styled from 'styled-components';
import {ReactComponent as IconoFlecha} from './../imagenes/flecha.svg';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';

const Btn = styled.button`
    display: block;
    width: 3.12rem; /* 50px */
    height: 3.12rem; /* 50px */
    line-height: 3.12rem; /* 50px */
    text-align: center;
    margin-right: 1.25rem; /* 20px */
    border: none;
    background: #001089;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.31rem; /* 5px */
    cursor: pointer;
 
    @media(max-width: 60rem){ /* 950px */
        width: 2.5rem; /* 40px */
        height: 2.5rem; /* 40px */
        line-height: 2.5rem; /* 40px */
    }
`;
 
const Icono = styled(IconoFlecha)`
    width: 50%;
    height: auto;
    fill: #fff;
`;




const BtnRegresarValida = ({ruta = '/',VerFormularioViaje}) => {
	const navigate = useNavigate();
    const onClickVolver = async (e) => {
        e.preventDefault();
        if(VerFormularioViaje===true)
             {navigate(ruta)}
             else{
                var salir = false   
                await Swal.fire({
                    title: 'Salir de Traslado',
                    text: '¿Desea regresar sin guardar el traslado?',
                    icon: 'warning',
                    showDenyButton: true,
                    denyButtonText: 'No',
                    confirmButtonText: 'Si',
                    confirmButtonColor: "blue"
                    }).then(response => {
                        if(response.isDenied)
                        {salir = true}
                    } 
                    )
                if(salir===true){return;}else{navigate(ruta)}    
            }    
            }

	return (
		<Btn  onClick={onClickVolver}><Icono /></Btn>
	);
}
 
export default BtnRegresarValida;